module.exports = __webpack_public_path__ + "img/manon-simenel.3ae2b7df.jpg";